import TandaTerima from '@adaptors-api/tanda-terima-api';
import { IMeta } from '@interfaces/imeta';
import { ITandaTerima } from '@interfaces/itanda-terima';
import { isFetchingData, setMetaData, setNotification } from '@pages/base/action';
import ActionTypes from '@store/action-types';
import { EnumLoading, DataName } from '@utils/constants';
import RequestAPI from '@utils/request-api';

const setLoading = (dispatch: any) => {
  dispatch(isFetchingData(EnumLoading.SET, DataName.TANDA_TERIMA));
};
const unsetLoading = (dispatch: any) => {
  dispatch(isFetchingData(EnumLoading.REMOVE, DataName.TANDA_TERIMA));
};

export const setTandaTerima = (tandaTerima?: ITandaTerima) => ({
  tandaTerima,
  type: ActionTypes.PAGE_TANDA_TERIMA_SET_TANDA_TERIMA,
});

export const setTandaTerimaList = (tandaTerimaList: ITandaTerima[]) => ({
  tandaTerimaList,
  type: ActionTypes.PAGE_TANDA_TERIMA_SET_TANDA_TERIMA_LIST,
});

export const fetchTandaTerima = (code: string) => (dispatch: any) => {
  setLoading(dispatch);

  if (!code) {
    dispatch(setTandaTerima(undefined));
    unsetLoading(dispatch);
    return;
  }

  return RequestAPI(TandaTerima.getTandaTerima(code))
    .then((response: any) => {
      const { data } = response.data;
      const tandaTerima: ITandaTerima = data;
      dispatch(setTandaTerima(tandaTerima));
      unsetLoading(dispatch);
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
    });
};

export const fetchTandaTerimaList = (params?: any, isSetMeta: boolean = true) => (
  dispatch: any,
) => {
  setLoading(dispatch);

  return RequestAPI(TandaTerima.getTandaTerimas(params))
    .then((response: any) => {
      const { data, meta } = response.data;
      const tandaTerimaList: ITandaTerima[] = data;
      const metaData: IMeta = meta;
      dispatch(setTandaTerimaList(tandaTerimaList));
      if (isSetMeta) {
        dispatch(setMetaData(metaData));
      }
      unsetLoading(dispatch);
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
    });
};

export const createTandaTerima = (body: ITandaTerima) => (dispatch: any) => {
  setLoading(dispatch);

  return RequestAPI(TandaTerima.createTandaTerima(body))
    .then((response: any) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: response.status === 200 ? 'success' : 'error',
        title: `Buat Tanda Terima ${response.status === 200 ? 'Sukses' : 'Gagal'}`,
        message: response.data.message,
      };
      dispatch(setNotification(notif));
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: 'error',
        title: `Buat Tanda Terima Gagal`,
        message: e.message,
      };
      dispatch(setNotification(notif));
    });
};

export const updateTandaTerima = (code: string, body: ITandaTerima) => (dispatch: any) => {
  setLoading(dispatch);

  return RequestAPI(TandaTerima.updateTandaTerima(code, body))
    .then((response: any) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: response.status === 200 ? 'success' : 'error',
        title: `Ubah Tanda Terima ${response.status === 200 ? 'Sukses' : 'Gagal'}`,
        message: response.data.message,
      };
      dispatch(setNotification(notif));
    })
    .catch((e: Error) => {
      unsetLoading(dispatch);
      const notif: any = {
        status: 'error',
        title: `Ubah Tanda Terima Gagal`,
        message: e.message,
      };
      dispatch(setNotification(notif));
    });
};
